import type ProductModel from 'coreClasses/product/ProductModel';

export const updateVariantId = (selectedProduct: ProductModel, sizesLength: number) => {
	if (sizesLength === 1) {
		const variants = selectedProduct.getVariants();

		if (variants && variants.length) {
			return variants[0].getProductId();
		}
	}

	return null;
};

export const isExchangeAllowed = (returnOrder, formValues, key, value) => {
	if (!value) {
		return false;
	}

	let exchangeAllowed = !formValues['exchangeProduct-' + key.split('-')[1]];

	const itemIndex = Number(key.split('_')[1]);

	if (!isNaN(itemIndex) && !exchangeAllowed) {
		const ids = returnOrder?.getProductItems(true).map((item) => item.getProductId()) || [];
		exchangeAllowed = ids.length ? ids[itemIndex] !== value : false;
	}

	return exchangeAllowed;
};

export const getSelectedItemsLength = (formValues) => {
	const keys = [];

	Object.entries(formValues).map(([key, value]) => {
		if (key.startsWith('returnProduct-') && value) {
			const newKey = key.replace('returnProduct-', '');
			keys.push(newKey);
		} else if (key.startsWith('exchangeProduct-') && value) {
			const newKey = key.replace('exchangeProduct-', '');
			keys.push(newKey);
		}
	});

	const length = keys.filter((value, index) => keys.indexOf(value) === index).length;

	return length;
};

export const isReturnRequested = (formValues: Record<string, any>) =>
	Object.entries(formValues)
		.filter(([key]) => key.startsWith('returnProduct-'))
		.some(([, value]) => value);
